import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-two-way-spot',
  templateUrl: './two-way-spot.component.html',
  styleUrls: ['./two-way-spot.component.scss']
})
export class TwoWaySpotComponent {
  @Input({ required: true }) indicesToHighlight: number[];
  @Input() public askName: string;
  @Input() public bidName: string;
  @Input() public midName: string;
  @Input() public form: FormGroup;
  @Input() public twoWayMode = true;
  @Input() public contentEditable = true;
  @Input() public pending = false;
  @Input() public incrementsScale = true;
  @Output() public changeInValueBlur = new EventEmitter<void>();
  private isFieldChangedSinceFocused = false;

  public onNumberChange(side: string, value: string): void {
    this.getFormControl(side).setValue(value);
    this.isFieldChangedSinceFocused = true;
  }

  public increaseSpot(shouldIncrease: boolean, by10Pips: boolean): void {
    const index = this.incrementsScale
      ? this.indicesToHighlight[this.indicesToHighlight.length - 1] + 1
      : 1;
    if (!this.indicesToHighlight) {
      return;
    }
    const valueToAdd = (by10Pips ? 10 : 1) / Math.pow(10, index);

    ['ask', 'bid', 'mid'].forEach(field => {
      const ctrl = this.getFormControl(field);

      if (!ctrl?.enabled) {
        return;
      }
      let newValue;
      if (shouldIncrease) {
        newValue = +ctrl.value + valueToAdd;
      } else {
        newValue = +ctrl.value - valueToAdd;
      }

      newValue = newValue.toFixed(
        Math.max(
          ctrl.value.split('.')[1]?.length || 0,
          valueToAdd.toString().split('.')[1]?.length || 0
        )
      );

      ctrl.setValue(newValue.toString());
    });
    this.changeInValueBlur.emit();
  }

  public onFocus(side: string): void {
    const ctrl = this.getFormControl(side);
    ctrl.markAsTouched();
  }

  public onFieldBlur(): void {
    if (this.isFieldChangedSinceFocused) {
      this.changeInValueBlur.emit();
    }
    this.isFieldChangedSinceFocused = false;
  }

  private getFormControl(side: string): AbstractControl<string> {
    if (side === 'ask') {
      return this.form.get(this.askName);
    } else if (side === 'bid') {
      return this.form.get(this.bidName);
    } else {
      return this.form.get(this.midName);
    }
  }
}
